module.exports = __webpack_public_path__ + "static/media/6.a3b6fde1.png";